<template>
<div class="overlay2" @click="overlayClick"  >
    <div class="popup">
        
      <div class="popup-content">
        

        <div class="header">
            <img v-if="selectedSubmission.Token.logoURI" :src="selectedSubmission.Token.logoURI" alt="Token Logo"  class="token-icon"/>
          <h2 class="name">{{ selectedSubmission.Token.name }}</h2>
          <h3 class="symbol">{{ selectedSubmission.Token.symbol }} </h3>
          
        </div>
        <p class="address">Address: {{ selectedSubmission.Token.address }}</p>
        <p class="id">Id: {{ selectedSubmission._id }}</p>
        <div class="buttons">
        <div class="button-line"></div>
          <button @click="showAbout" :class="{ active: currentTab === 'about' }">About</button>
          <button @click="showExtensions" :class="{ active: currentTab === 'extensions' }">Extensions</button>
          <button @click="showMoreInfo" :class="{ active: currentTab === 'moreInfo' }">More Info</button>
        </div>
  
        
        <div v-if="currentTab === 'about'" class="content">
          <div>This is the about section.</div>
        </div>
        <div v-if="currentTab === 'extensions'" class="content">
          <div>l2GatewayAddress: {{ selectedSubmission.Token.extensions.l2GatewayAddress }}</div>
          <div>l1GatewayAddress: {{ selectedSubmission.Token.extensions.l1GatewayAddress }}</div>
          <div>l1Address: {{ selectedSubmission.Token.extensions.l1Address }}</div>
        </div>
        <div v-if="currentTab === 'moreInfo'" class="content">
          <div>Chain ID: {{ selectedSubmission.Token.chainID }}</div>
          <div>Signing Address: {{ selectedSubmission.Token.SigningAddress }}</div>
        </div>
  
        <button @click="closePopup" class="close-button">Close</button>
      </div>
    </div>
</div>
  </template>
  
  <script>
  export default {
    props: {
      selectedSubmission: {
        type: Object,
        required: true,
      },
      
      
    },
    data() {
      return {
        currentTab: 'about',

      };
    },
    methods: {
      closePopup() {
        this.$emit('close');
      },
      showAbout() {
        this.currentTab = 'about';
      },
      showExtensions() {
        this.currentTab = 'extensions';
      },
      showMoreInfo() {
        this.currentTab = 'moreInfo';
      },

      overlayClick(event) {
      // Check if the click event target is the overlay itself (not a child element of the popup)
      if (event.target === event.currentTarget) {
        this.closePopup();
      }
    },
    },
  };
  </script>
  
  <style scoped>

.overlay2 {
  /* Adjust styles for the overlay here */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Grey overlay with 50% opacity */
  backdrop-filter: blur(1px); /* Apply blur effect */
  z-index: -1; /* Make sure the overlay is above other content */
}
  .popup {
    /* Adjust styles as needed */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color:  #a8a9ac;
    
    padding: 20px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.2);
    width: 60%;
    height: 60%;
    z-index: 20;
  }
  
  .popup-content {
    z-index: 30;
    /* Add styles for popup content here */
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .token-icon{
border-radius: 6px;

  }
  .name {
    font-size: 36px;
  }
  
  .symbol {
    font-size: 36px;
  }
  
  .address {
    /* Add styles for address here */
    font-size: 24px;
    color: black;
    font-weight: bold;
  }
  
  .id {
    /* Add styles for id here */
    justify-content: left;
    color: black;
    font-weight: bold;
  }
  
  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    position: relative;
    
    
  }
  
  button {
    /* Add styles for buttons here */
    border-radius: 0%;
  }
  .button-line {
    position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: black;
  transform: translateY(-50%);
  z-index: -1;
}

  .content {
    /* Add styles for content here */
    font-size: 24px;
    color: rgb(0, 0, 0);
  }
  
  .active {
    /* Add styles for active button here */
    color: rgb(170, 222, 155);
    
  }
  
  .close-button {
    /* Add styles for close button here */
  /* Add styles for close button here */
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 8px 16px;
  font-size: 16px;
  background-color: #ef8b8b;
  border: 1px solid #000000;
  border-radius: 4px;


  }
  </style>
  